var __jsx = React.createElement;
import DixuContainer from "../../components/DixuContainer/DixuContainer";
import { DixuCol, DixuRow } from "../../components/DixuGrid/DixuGrid";
import DixuHead from "../../components/DixuHead/DixuHead";
import DixuImage from "../../components/DixuImage/DixuImage";
import DixuLink from "../../components/DixuLink/DixuLink";
import DixuText from "../../components/DixuText/DixuText";
import DixuTitle from "../../components/DixuTitle/DixuTitle";
import { useTranslation } from "../../i18n";
import React from 'react';
import NordeaIcon from "../../public/images/nordea.svg";
import FortumIcon from "../../public/images/fortum.svg";
import IfIcon from "../../public/images/if.svg";
import IskuIcon from "../../public/images/isku.svg";
import LaattapisteIcon from "../../public/images/laattapiste.svg";
import HuoneistogurutIcon from "../../public/images/huoneistogurut.svg";
import { toRem } from "../../utils/Utils";
const Header = () => {
  const {
    t
  } = useTranslation(['partners']);
  return /*#__PURE__*/React.createElement(DixuTitle.PageTitle, {
    subtitle: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Subtitle.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "/ota-yhteytta",
      weight: "bold"
    }, t('partners:Subtitle.Content2')), t('partners:Subtitle.Content3'))
  }, t('partners:PageTitle'));
};
const Partner = _ref => {
  let {
    name,
    image,
    content
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "box-shadow-2 border-radius-md bg-2-1 p-24"
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 32]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    justify: "center",
    align: "middle"
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 18
  }, image))), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 4]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "4",
    color: "2-8",
    weight: "bold"
  }, name)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(DixuText, {
    font: "3",
    color: "2-8",
    weight: "medium",
    whiteSpace: "pre-line"
  }, content))))));
};
const Partners = () => {
  const {
    t
  } = useTranslation(['partners']);
  const partners = [{
    name: 'Nordea',
    image: /*#__PURE__*/React.createElement(NordeaIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: t('partners:Nordea.Content1')
  }, {
    name: 'Fortum',
    image: /*#__PURE__*/React.createElement(FortumIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Fortum.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://www.fortum.fi/kotiasiakkaille/sahkoa-kotiin/muuttoilmoitus-sahkosopimus-heti-muuttajalle",
      weight: "bold",
      external: true
    }, t('partners:Fortum.Content2')))
  }, {
    name: 'If',
    image: /*#__PURE__*/React.createElement(IfIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://www.if.fi/henkiloasiakkaat/vakuutukset/kotivakuutus?utm_source=dixu.fi&utm_medium=banner&utm_campaign=b2c_home&utm_content=etusivu",
      weight: "bold",
      external: true
    }, t('partners:If.Content1')), ' ', t('partners:If.Content2'))
  }, {
    name: 'Isku',
    image: /*#__PURE__*/React.createElement(IskuIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Isku.Content1'))
  }, {
    name: 'Laattapiste',
    image: /*#__PURE__*/React.createElement(LaattapisteIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Laattapiste.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://www.laattapiste.fi/kotiin/palvelut/",
      weight: "bold",
      external: true
    }, t('partners:Laattapiste.Content2')))
  }, {
    name: 'Keittiömaailma',
    image: /*#__PURE__*/React.createElement(DixuImage, {
      src: "/images/keittiomaailma.png",
      fit: "contain",
      height: 168
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Keittiomaailma.Content1'))
  }, {
    name: 'Drop',
    image: /*#__PURE__*/React.createElement(DixuImage, {
      src: "/images/drop.png",
      fit: "contain",
      height: 168
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Drop.Content1'))
  }, {
    name: 'Huoneistogurut',
    image: /*#__PURE__*/React.createElement(HuoneistogurutIcon, {
      style: {
        height: toRem(168)
      },
      width: "100%"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Huoneistogurut.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://www.huoneistogurut.fi/yhteystiedot",
      weight: "bold",
      external: true
    }, t('partners:Huoneistogurut.Content2')))
  }, {
    name: 'Suomen Sisustustakka',
    image: /*#__PURE__*/React.createElement(DixuImage, {
      src: "/images/suomen_sisustustakka.png",
      fit: "contain",
      height: 168
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:SuomenSisustustakka.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://www.suomensisustustakka.fi/tuote-osasto/hormittomat/",
      weight: "bold",
      external: true
    }, t('partners:SuomenSisustustakka.Content2')))
  }, {
    name: 'Properta',
    image: /*#__PURE__*/React.createElement(DixuImage, {
      src: "/images/properta.png",
      fit: "contain",
      height: 168
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, t('partners:Properta.Content1'), ' ', /*#__PURE__*/React.createElement(DixuLink, {
      href: "https://properta.fi/",
      weight: "bold",
      external: true
    }, t('partners:Properta.Content2')))
  }].map(partner => {
    return /*#__PURE__*/React.createElement(DixuCol, {
      key: partner.name,
      xs: 24,
      md: 12,
      xl: 8,
      type: "flex"
    }, /*#__PURE__*/React.createElement(Partner, partner));
  });
  return /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [24, 24]
  }, partners);
};
const DixuPartnersScreen = () => {
  const {
    t
  } = useTranslation(['partners']);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DixuHead, {
    title: t('partners:Metadata.Title'),
    description: t('partners:Metadata.Description')
  }), /*#__PURE__*/React.createElement(DixuContainer, null, /*#__PURE__*/React.createElement(DixuRow, {
    gutter: [0, 74]
  }, /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(Header, null)), /*#__PURE__*/React.createElement(DixuCol, {
    span: 24
  }, /*#__PURE__*/React.createElement(Partners, null)))));
};
export default DixuPartnersScreen;